import dynamic from 'next/dynamic';
import { NewProductProps } from './types';

const NewProduct = dynamic(
  () => import('@/components/collections/[handle]/NewProductPage'),
  {
    ssr: true,
  },
);

const NewProductV2 = dynamic(
  () => import('@/components/collections/[handle]/NewProductPage/v2'),
  {
    ssr: true,
  },
);

const NewProductPageLayout = (props: NewProductProps) => {
  const { shouldUseRVariants } = props;

  if (shouldUseRVariants) return <NewProductV2 {...props} key={props.handle} />;

  // Default case: Do not use rVariants and render the original product component
  return <NewProduct {...props} key={props.handle} />;
};

export default NewProductPageLayout;
